import jrpc20WSClient from "./jrpc20WSClient";
import employee from "./employee";

class order {

    wsClient = new jrpc20WSClient(process.env.REACT_APP_BACKEND_WS_URL, process.env.REACT_APP_BACKEND_WS_USR, process.env.REACT_APP_BACKEND_WS_PWD)
    
    getOrderList() {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data: {}
            }
            this.wsClient.request('post', 'order/order/getEmployeeOrderList', post_data).then((result) => {
                resolve(result.call_data.order);
            }).catch((error) => {
                reject(error);
            });
        });
    }
    getInfo(data) {
        let employee_obj = new employee();
        return new Promise((resolve, reject) => {
            let post_data = {
                user_data: { token: employee_obj.token },
                call_data:data
            }
            this.wsClient.request('post', 'order/order/getInfo', post_data).then((result) => {
                resolve(result.call_data.order);
            }).catch((error) => {
                reject(error);
            });
        });
    }

}

export default order;